module.exports = __webpack_public_path__ + "static/media/arrival-icon.59e44835.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/arrival-icon.svg
// module id = 913
// module chunks = 0